import { createSlice } from '@reduxjs/toolkit';

import { TEXT_BANNER_VARIANT, VARIANT_GRADIENT } from './bannerConstants';
import { INFO } from '../notifications/notificationsConstants';
import { BANNER_SLICE_NAME } from '../slicesNames';

const initialState = {
  showBanner: false,
  variant: TEXT_BANNER_VARIANT,
  color: undefined,
  text: '',
  hasDismissed: false,
  styleVariant: VARIANT_GRADIENT,
  icon: INFO,
};

const bannerSlice = createSlice({
  name: BANNER_SLICE_NAME,
  initialState,
  reducers: {
    showBanner(state, action) {
      const { variant = 'text', text, color, styleVariant, icon } = action.payload;
      state.variant = variant;
      state.text = text;
      state.showBanner = true;
      state.color = color;
      state.styleVariant = styleVariant;
      state.icon = icon;
    },
    hideBanner(state) {
      state.showBanner = false;
    },
    dismiss(state) {
      state.showBanner = false;
      state.hasDismissed = true;
    },
  },
});

export default bannerSlice;
export const { showBanner, hideBanner, dismiss } = bannerSlice.actions;
